export default {
  'apiCallResponse.title': 'API Response Mappings',

  'apiCallResponse.form.responseHttpStatusCode': 'Http Response Code',
  'apiCallResponse.form.responseParameterPosition': 'Response Parameter Position',
  'apiCallResponse.form.valueDestination': 'Value Destination',

  'apiCallResponse.form.form': 'Form',
  'apiCallResponse.form.field': 'Field',
  'apiCallResponse.form.variable': 'Variable',
  'apiCallResponse.form.parameterCodification': 'Parameter Encoding',

  'apiCallResponse.form.parameterValueFilterComparisonOperator': 'Filter Operator',
  'apiCallResponse.form.parameterValueFilter': 'Parameter Filter Value',

  'apiCallResponse.form.formFieldValueDestination': 'Field Value Destination',

  'apiCallResponse.form.tableParameterName': 'List Parameter Name',
  'apiCallResponse.form.parameterName': 'Parameter Name',
  'apiCallResponse.form.attachmentFileName': 'Attachment Name',
  'apiCallResponse.form.attachmentContentType': 'Content Type',

  'apiCallResponse.form.select.FormField': 'Form / Field',
  'apiCallResponse.form.select.Variable': 'Variable',
  'apiCallResponse.form.select.InstanceName': 'Request Name',
  'apiCallResponse.form.select.OperationObservations': 'Operation Observations',
  'apiCallResponse.form.select.OperationUserEmail': 'Operation User Email',
  'apiCallResponse.form.select.OperationIsApprovalOrReject': 'Approval / Rejection Indicator',

  'apiCallResponse.form.select.FieldValue': 'Display Value',
  'apiCallResponse.form.select.FieldSearchValue': 'Search Value',

  'apiCallResponse.form.select.None': 'No Encoding',
  'apiCallResponse.form.select.ByteArray': 'Byte Array',
  'apiCallResponse.form.select.Base64String': 'Base64 String',
  'apiCallResponse.form.select.ZipByteArray': 'Zip File - Byte Array',
  'apiCallResponse.form.select.ZipBase64String': 'Zip File - Base64 String',
  'apiCallResponse.form.select.HttpBodyBinaryData': 'Binary Encoded in Request Body',

  'apiCallResponse.form.select.Header': 'Header',
  'apiCallResponse.form.select.Url': 'Url',
  'apiCallResponse.form.select.FormData': 'Form Data',
  'apiCallResponse.form.select.BodyJson': 'Body (JSON)',
  'apiCallResponse.form.select.XWwwFormUrlEncoded': 'Form URL Encoded',
  'apiCallResponse.form.select.Authorization': 'Authorization',
  'apiCallResponse.form.select.BodyText': 'Body (Text)',
  'apiCallResponse.form.select.FormFileData': 'Form / File',

  'apiCallResponse.form.select.Equal': 'Equal',
  'apiCallResponse.form.select.NotEqual': 'Not Equal',
  'apiCallResponse.form.select.GreaterThan': 'Greater Than',
  'apiCallResponse.form.select.GreaterThanOrEqual': 'Greater Than Or Equal',
  'apiCallResponse.form.select.LessThan': 'Less Than',
  'apiCallResponse.form.select.LessThanOrEqual': 'Less Than Or Equal',
  'apiCallResponse.form.select.Contains': 'Contains',
  'apiCallResponse.form.select.NotContains': 'Does Not Contain',
  'apiCallResponse.form.select.IsNull': 'Is Null',
  'apiCallResponse.form.select.IsNotNull': 'Is Not Null',
};
